import styled from 'styled-components';
import { Box, Card, Heading, Link, Stack, Text } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { IconRight1 } from '@99designs/icons';
import { FeaturesList } from '@99designs/marketing-ui';
import type { CollaborationContent } from './collaborationMethods';

export interface CollaborationMethodProps extends CollaborationContent {
    type: string;
}

const StyledCard = styled(Card)<{ type: string }>`
    position: relative;
    background-color: ${colors.grey050};
    background-repeat: no-repeat;
    background-size: 136px 136px;
    background-position: bottom right;
    ${({ type }) =>
        `background-image: url('https://99designs-start-static.imgix.net/product-details/collaboration-methods/${type}.png');`}
`;

export function CollaborationMethod({
    title,
    description,
    inclusions,
    link,
    type,
}: CollaborationMethodProps) {
    return (
        <>
            <Box paddingBottom="1bu">
                <Heading appearanceLevel={4} accessibilityLevel={2}>
                    {__('Collaboration method')}
                </Heading>
            </Box>
            <StyledCard appearance="filled" type={type}>
                <Stack space="0.5bu">
                    <Heading appearanceLevel={5} accessibilityLevel={3}>
                        {title}
                    </Heading>
                    <Text>{description}</Text>
                    <Box width={['95%', '85%', '80%', '80%']}>
                        <FeaturesList features={inclusions} />
                    </Box>

                    <Link href={link.href} openInNewTab>
                        {__('Find out more')}
                        <Box as="span" marginLeft="0.25bu">
                            <IconRight1 />
                        </Box>
                    </Link>
                </Stack>
            </StyledCard>
        </>
    );
}
